import { Info } from "@emotion-icons/material/Info";
import Section from "../Section";
import { H3 } from "../Headers/Headings";
import Button from "../Button/Button";
import { useLocation, useNavigate } from "react-router-dom";
import Card from "../Card/Card";
import styles from "./ExpiredSubscriptionMessage.module.css";

export const ExpiredSubscriptionMessage = ({ title, body, button }: { title?: string; body: string; button?: string }) => {
  const navigate = useNavigate();
  const location = useLocation();

  if (location.pathname === "/activate-subscription") {
    return null;
  }

  return (
    <Section>
      <Card className={styles.card}>
        <Info size='1.5rem' />
        <div className={styles.content}>
          {title && <H3 variant='noTop'>{title}</H3>}
          <p className={styles.body}>{body}</p>
          {button && <Button onClick={() => navigate(`/pricing`)}>{button}</Button>}
        </div>
      </Card>
    </Section>
  );
};
